import { Params } from '@angular/router';
import { ActiveFilter, Filter } from '@epicuro-next/models/filters';
import { isFilterOfType } from '@epicuro-next/utilities';

export function getInitialSelectedFiltersFromQueryParams(
  availableFilters: Filter[],
  params: Params,
  ignoreValuesValidationIds: string[] = [],
): ActiveFilter[] {
  return Object.entries(params)
    .filter(([id]) => availableFilters.some((f) => f.id === id))
    .map(([id, paramValues]) => {
      try {
        const values: string[] =
          typeof paramValues === 'string'
            ? paramValues.split('|')
            : paramValues;
        const availableFilterValues =
          availableFilters
            .find(isFilterOfType(id))
            ?.values?.map(({ name }) => name) ?? [];

        const validValues = ignoreValuesValidationIds.includes(id)
          ? values
          : values.filter((v) => availableFilterValues.includes(v));
        return {
          id,
          values: validValues,
        };
      } catch (e) {
        return {
          id,
          values: [],
        };
      }
    })
    .filter(({ values }) => values.length);
}
